<template>
  <div>
    <v-dialog
      scrollable
      :width="classifications.length ? '90%' : '300'"
      v-model="show"
    >
      <v-card>
        <v-card-title class="pb-0 px-4">
          <v-tabs
            v-if="classifications.length"
            @change="getMetricClassificationAssigns"
            v-model="tabModel"
          >
            <v-tab
              v-for="(tab, tabKey) in classifications"
              :key="tabKey"
            >
              {{ tab.Classification_Title }}
            </v-tab>
            <v-spacer></v-spacer>
            <v-btn
              icon
              @click.prevent="show = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-tabs>
          <span v-else>Metrics Manager</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-2">
          <v-tabs-items v-model="tabModel" v-if="classifications.length">
            <v-tab-item
              class="pa-2"
              v-for="(tabItem, tabItemKey) in classifications"
              :key="tabItemKey"
            >
              <v-expansion-panels
                multiple
                v-model="panel"
              >
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    Classification settings
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row v-if="currentClassification">
                      <v-col cols="12" md="6">
                        <v-text-field
                          dense
                          hide-details
                          label="Title"
                          v-model="currentClassification.Classification_Title"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-select
                          dense
                          hide-details
                          :items="employeeStatuses"
                          item-text="Status_Descr"
                          item-value="Status_ID"
                          label="Assign To"
                          multiple
                          v-model="currentClassification.assigns"
                        >
                          <template v-slot:selection="{ item, index }">
                            <span v-if="index === 0">{{ item.Status_Descr }}</span>
                            <span
                              v-if="index === 1"
                              class="grey--text text-caption pl-2"
                            >
                              (+{{ currentClassification.assigns.length - 1 }} others)
                            </span>
                          </template>
                        </v-select>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-switch
                          dense
                          hide-details
                          v-model="currentClassification.Enabled"
                          label="Enabled"
                          class="mt-0"
                        ></v-switch>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-btn
                          small
                          color="red darken-2 white--text"
                          v-if="listOfMetrics[tabModel] && !listOfMetrics[tabModel].length"
                          @click="removeClassificationDialog = true"
                        >
                          Delete
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel v-if="listOfMetrics[tabModel] && listOfMetrics[tabModel].length">
                  <v-expansion-panel-header>
                    List Of Metrics
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-data-table
                      :key="updateTableKey"
                      dense
                      :headers="listOfMetricsHeaders"
                      :items="listOfMetrics[tabModel]"
                      :items-per-page="-1"
                      hide-default-footer
                    >
                      <template v-slot:[`item.Enabled`]="{ item }">
                        <v-switch
                          dense
                          hide-details
                          class="ma-0"
                          label="Enabled"
                          v-model="item.Enabled"
                          @change="updateMetric(item)"
                        ></v-switch>
                      </template>
                      <template v-slot:[`item.Actions`]="{ item }">
                        <v-btn
                          small
                          icon
                          color="primary"
                          @click="showEditMetricDialog(item)"
                        >
                          <v-icon>mdi-pencil-circle</v-icon>
                        </v-btn>
                        <v-btn
                          small
                          icon
                          color="red darken-2"
                          @click="showDeleteDialog(item)"
                        >
                          <v-icon>mdi-delete-circle</v-icon>
                        </v-btn>
                      </template>
                    </v-data-table>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-tab-item>
          </v-tabs-items>
          <span v-else>You have not any metrics.</span>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small color="primary" v-if="isChanged" @click="updateClassification">Update</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ConfirmOrDeniedDialog
      v-if="removeClassificationDialog"
      v-model="removeClassificationDialog"
      :message="'You can\'t restore this classification after you delete it!'"
      :mode="confirmOrDeniedDialogModes.delete"
      @onDeleteClick="removeClassification"
      @onCancelClick="removeClassificationDialog = false"
      @onCloseClick="removeClassificationDialog = false"
    />
    <v-dialog
      v-model="showEditMetric"
      width="90%"
      max-width="800"
    >
      <v-card>
        <v-card-title>
          Edit Metric
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-row v-if="currentEditMetric" class="py-4">
            <v-col cols="12" md="6" class="py-4">
              <v-text-field
                dense
                hide-details
                label="Title"
                v-model="currentEditMetric.Title"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" class="py-4">
              <v-textarea
                dense
                hide-details
                label="Essensce"
                v-model="currentEditMetric.Essensce"
              ></v-textarea>
            </v-col>
            <v-col cols="12" md="6" class="py-4">
              <v-textarea
                dense
                hide-details
                label="Calculation"
                v-model="currentEditMetric.Calculation"
              ></v-textarea>
            </v-col>
            <v-col cols="12" md="6" class="py-4">
              <v-textarea
                dense
                hide-details
                label="Limit Value"
                v-model="currentEditMetric.Limit_Value"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            small
            outlined
            color="primary"
            @click="showEditMetric = false"
          >
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            small
            color="primary"
            :disabled="!canUpdate"
            @click="updateMetric(currentEditMetric)"
          >
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ConfirmOrDeniedDialog
      v-if="showDeleteMetricDialog"
      v-model="showDeleteMetricDialog"
      :message="'You can\'t restore data after delete!'"
      :mode="confirmOrDeniedDialogModes.delete"
      @onDeleteClick="deleteMetric"
      @onCancelClick="hideDeleteDialog"
      @onCloseClick="hideDeleteDialog"
    />
  </div>
</template>
<script>
import { getApiErrorMessage } from '@/utils/apiError'
export default {
  name: 'MetricsManager',
  components: {
    ConfirmOrDeniedDialog: () => import('@/components/global/ConfirmOrDeniedDialog.vue')
  },
  props: {
    value: {
      required: false,
      default: false
    }
  },
  data () {
    return {
      tabModel: 0,
      panel: [0],
      employeeStatuses: [],
      classifications: [],
      listOfMetrics: {},
      updateTableKey: 0,
      currentClassification: null,
      showEditMetric: false,
      removeClassificationDialog: false,
      currentEditMetric: null,
      metricToDeleteID: null,
      showDeleteMetricDialog: false,
      listOfMetricsHeaders: [
        {
          text: 'Title',
          value: 'Title',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2'
        },
        {
          text: 'Essensce',
          value: 'Essensce',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2'
        },
        {
          text: 'Calculation',
          value: 'Calculation',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2'
        },
        {
          text: 'Limit Value',
          value: 'Limit_Value',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2'
        },
        {
          text: 'Enabled',
          value: 'Enabled',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2'
        },
        {
          text: '',
          value: 'Actions',
          align: 'center',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap'
        }
      ]
    }
  },
  computed: {
    user () {
      return this.$store.getters.getUser
    },
    confirmOrDeniedDialogModes () {
      return this.$store.getters.getConfirmOrDeniedDialogModes
    },
    show: {
      get () {
        this.getEmployeeStatuses()
        this.getMetricClassifications()
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    canUpdate () {
      let res = false
      if (this.currentEditMetric && this.listOfMetrics[this.tabModel]) {
        const originalMetric = this.listOfMetrics[this.tabModel].filter(item => item.PR_Matrix_ID === this.currentEditMetric.PR_Matrix_ID)[0]
        for (const key in this.currentEditMetric) {
          if (this.currentEditMetric[key] !== originalMetric[key]) {
            res = true
            break
          }
        }
      }
      return res
    },
    isChanged () {
      let res = false
      if (this.currentClassification) {
        for (const key in this.currentClassification) {
          if (typeof this.currentClassification[key] === 'object') {
            if (this.currentClassification[key].length !== this.classifications[this.tabModel][key].length) {
              res = true
              break
            }
            for (let i = 0; i < this.currentClassification[key].length; i++) {
              if (this.classifications[this.tabModel][key].indexOf(this.currentClassification[key][i]) === -1) {
                res = true
                break
              }
            }
          } else {
            res = !(this.currentClassification[key] === this.classifications[this.tabModel][key])
          }
          if (res) break
        }
      }
      return res
    }
  },
  mounted () {
    this.getEmployeeStatuses()
    this.getMetricClassifications()
  },
  methods: {
    showDeleteDialog (item) {
      this.metricToDeleteID = item.PR_Matrix_ID
      this.showDeleteMetricDialog = true
    },
    hideDeleteDialog () {
      this.metricToDeleteID = null
      this.showDeleteMetricDialog = false
    },
    showEditMetricDialog (item) {
      this.currentEditMetric = Object.assign({}, item)
      this.showEditMetric = true
    },
    deleteMetric () {
      this.axios.delete(`/api/metrics/delete_metric/${this.metricToDeleteID}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.$store.dispatch('setSuccess', { successMsg: 'Metric successfully deleted' })
        const ind = this.listOfMetrics[this.tabModel].findIndex(item => item.PR_Matrix_ID === this.metricToDeleteID)
        this.listOfMetrics[this.tabModel].splice(ind, 1)
        this.metricToDeleteID = null
        this.showDeleteMetricDialog = false
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    updateMetric (item) {
      this.axios.put('/api/metrics/update_metric', item, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.$store.dispatch('setSuccess', { successMsg: 'Metric successfully updated' })
        if (this.showEditMetric) {
          const ind = this.listOfMetrics[this.tabModel].findIndex(item => item.PR_Matrix_ID === this.currentEditMetric.PR_Matrix_ID)
          this.$set(this.listOfMetrics[this.tabModel], ind, {
            ...this.currentEditMetric
          })
          this.currentEditMetric = null
          this.updateTableKey++
          this.showEditMetric = false
        }
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    getMetrics (classificationID) {
      this.axios.get(`/api/metrics/get_metrics/${classificationID}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.listOfMetrics[this.tabModel] = res.data
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    getMetricClassificationAssigns () {
      const classificationID = this.classifications[this.tabModel].Classification_ID
      if (!this.listOfMetrics[this.tabModel]) this.getMetrics(classificationID)
      if (this.classifications[this.tabModel].assigns.length) {
        this.currentClassification = Object.assign({}, this.classifications[this.tabModel])
        return
      }
      this.axios.get(`/api/metrics/classification_assigns/${classificationID}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.classifications[this.tabModel].assigns = []
        for (let i = 0; i < res.data.length; i++) {
          this.classifications[this.tabModel].assigns.push(res.data[i].Employee_Status_ID)
        }
        this.currentClassification = Object.assign({}, this.classifications[this.tabModel])
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    getMetricClassifications () {
      this.axios.get('/api/metrics/classifications', {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.classifications = []
        for (let i = 0; i < res.data.length; i++) {
          this.classifications.push({
            ...res.data[i],
            assigns: [],
            listOfMetrics: []
          })
        }
        if (this.classifications.length) {
          this.getMetricClassificationAssigns()
        }
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    getEmployeeStatuses () {
      this.axios.get('/api/metrics/employee_statuses', {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.employeeStatuses = res.data
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    updateClassification () {
      this.axios.put('/api/metrics/classification', this.currentClassification, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.classifications[this.tabModel].Classification_Title = res.data[0].Classification_Title
        this.classifications[this.tabModel].Enabled = res.data[0].Enabled
        this.classifications[this.tabModel].assigns = []
        for (let i = 0; i < this.currentClassification.assigns.length; i++) {
          this.classifications[this.tabModel].assigns.push(this.currentClassification.assigns[i])
        }
        this.$store.dispatch('setSuccess', { successMsg: 'Classification successfully updated' })
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    removeClassification () {
      this.axios.delete(`/api/metrics/classification/${this.currentClassification.Classification_ID}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.removeClassificationDialog = false
        this.$store.dispatch('setSuccess', { successMsg: 'Classification successfully removed' })
        this.tabModel = 0
        this.getMetricClassifications()
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    }
  }
}
</script>
<style lang="">

</style>
